function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelope2 = function SvgEnvelope2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17,
    viewBox: "0 0 24 17"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1807.19 31h-18.38a2.765 2.765 0 0 0-2.81 2.713v11.574a2.765 2.765 0 0 0 2.81 2.713h18.38a2.765 2.765 0 0 0 2.81-2.713V33.713a2.765 2.765 0 0 0-2.81-2.713Zm-.17 1.809-9.02 6.468-9.02-6.469h18.04Zm.17 13.383h-18.38a.929.929 0 0 1-.94-.9V34.267l10.13 7.264 10.12-7.264v11.02a.92.92 0 0 1-.93.905Z",
    transform: "translate(-1786 -31)",
    style: {
      fill: "#1c171c",
      fillRule: "evenodd"
    }
  }));
};
export default SvgEnvelope2;